import { useCallback } from "react";

// Used by useQueryParamsManager only
export const useMockableLocation = () => {
  return useCallback(() => {
    return window.location;
  }, []);
};
